import { useEffect, useState, useRef } from "react";
import { useNavigate } from 'react-router-dom';
import { User, Mail, AlignLeft, IdCard, Store, ListCheck, Phone, ExternalLink, MapPinIcon, CalendarDays, Image, LockIcon, Binary } from "lucide-react";

import useDocumentTitle from '../../hooks/useDocumentTitle';
import { creatstore, fetchcountries, fetchstates, fetchcities } from "../../services/api";
import toastr from 'toastr';
import 'toastr/build/toastr.min.css';
import { useLocation } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";

import Flatpickr from "react-flatpickr";
import "flatpickr/dist/themes/light.css";

import { DateInput } from "@mantine/dates";
import LocationSelector from "./LocationSelector";
import NewPlaceAutocomplete from "./NewPlaceAutocomplete";

export default function AddStore() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const generateCardNumber = () => {
    // Get current date/time components
    const now = new Date();
    const hours = now.getHours().toString().padStart(2, '0');
    const minutes = now.getMinutes().toString().padStart(2, '0');
    const seconds = now.getSeconds().toString().padStart(2, '0');
    const day = now.getDate().toString().padStart(2, '0');
    const month = (now.getMonth() + 1).toString().padStart(2, '0');

    // Combine date/time components (this will be 12 digits)
    const timeDigits = `${month}${day}${hours}${minutes}${seconds}`;

    // Generate random digits to fill remaining space (if needed)
    const randomDigits = Math.floor(Math.random() * 10000).toString().padStart(4, '0');
    const cardNumber = `${user.id}${randomDigits}${timeDigits}`.substring(0, 16);
    // Format with spaces for better readability
    const formattedNumber = cardNumber.replace(/(\d{0})/g, '$1').trim();

    return formattedNumber;
  };
  const location = useLocation();
  useDocumentTitle('Welcome to Admin | Add New Store');
  const [CountryList, setCountryList] = useState([])
  const [StateList, setStateList] = useState([]);
  const [CityList, setCityList] = useState([]);
  const fileInputRef = useRef(null);
  // const [selectedCountry, setselectedCountry] = useState([]);
  const [formData, setFormData] = useState({
    store_name: "",
    store_id: generateCardNumber(),
    address: "",
    email: "",
    phone: "",
    pincode: "",
    noOfPass: "",
    OTPAllowed: '1',
    FaceRecognition: '0',
    vendortype: '0',
    swipelimit: '0',
    monthlyswipe: '0',
    swipeinyear: '0',
    event_date: new Date(),
  });
  const baseURL = 'https://www.ozilcrm.com/'
  // const baseURL = 'http://127.0.0.1:8000/'
  const handleChange = (e) => {
    const { name, type, value, files } = e.target;
    console.log(name);
    console.log(value);

    if (type === "file" && files.length > 0) {
      const file = files[0];
      const reader = new FileReader();

      reader.onloadend = () => {
        setFormData((prev) => ({
          ...prev,
          [name]: file, // actual file
          [`${name}_preview`]: reader.result, // preview URL
        }));
      };

      reader.readAsDataURL(file);
    } else {
      setFormData((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };

  const handleChangeDate = (e, field = '') => {
    let name = '';
    let value = '';
    if (e.target) {
      name = e.target.name;
      value = e.target.value;
    } else {
      name = field//field.name;
      value = e;
    }
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };


  const [pathnameChanged, setPathnameChanged] = useState(location.pathname);

  useEffect(() => {
    setPathnameChanged(location.pathname);
  }, [location.pathname]);

  useEffect(() => {
    if (pathnameChanged === '/store/edit') {
      const editData = localStorage.getItem('storeEditData');
      if (editData) {
        const parsedData = JSON.parse(editData);
        setFormData(parsedData);
      }
    } else {
      localStorage.removeItem('storeEditData');
    }

    fetchcountrylist();
  }, [pathnameChanged]);

  const fetchcountrylist = async () => {
    const country = await fetchcountries();
    setCountryList(country.result);
    const editData = localStorage.getItem('storeEditData');
    if (editData) {
      const editparseddata = JSON.parse(editData)
      if (country?.result?.length > 0) {
        const states = await fetchstates(editparseddata.country);


        setStateList(states.result);
        if (states) {
          const cities = await fetchcities(editparseddata.state, editparseddata.country);
          setCityList(cities.result);
        }
      }
    }
  }

  const handleState = async (e) => {
    // setselectedCountry(e)
    const value = e.target.value;
    const states = await fetchstates(value);
    setStateList(states.result);

  };
  const handleCity = async (e) => {
    // const countryId = selectedCountry.id
    const value = e.target.value;
    const cities = await fetchcities(value, formData.country);
    setCityList(cities.result);
  };


  const handleSubmit = async (e) => {

    e.preventDefault();
    const formDataToSend = new FormData();
    for (let key in formData) {
      if (key === "store_logo") {
        if (!formData[key] || typeof formData[key] === "string") {
          continue;
        }
      }
      if (formData[key] === null || formData[key] === "") {
        continue;
      }
      formDataToSend.append(key, formData[key]);
    }
    if (!formData.store_name || formData.store_name === "") {
      toastr.error("Please Enter Store Name")
      return false
    }

    if (!formData.type || formData.type === "") {
      toastr.error("Please Enter Store Type")
      return false
    }

    if (!formData.contact_name || formData.contact_name === "") {
      toastr.error("Please Enter Contact Name")
      return false
    }
    if (!formData.country || formData.country === "") {
      toastr.error("Please Enter Country")
      return false
    }

    if (!formData.state || formData.state === "") {
      toastr.error("Please Enter state")
      return false
    }
    if (!formData.city || formData.city === "") {
      toastr.error("Please Enter city")
      return false
    }
    if (!formData.email || formData.email === "") {
      toastr.error("Please Enter Email")
      return false
    }

    if (pathnameChanged === '/store/edit') { } else {

      if (!formData.password || formData.password === "") {
        toastr.error("Please Enter Password")
        return false
      }

      if (!formData.password_confirmation || formData.password_confirmation === "") {
        toastr.error("Please Enter Password Confirmation")
        return false
      }

      if (formData.password && formData.password !== "" && formData.password_confirmation && formData.password_confirmation !== "" && formData.password_confirmation !== formData.password) {
        toastr.error("Password Mismatch")
        return false
      }
    }

    if (!formData.phone || formData.phone === "") {
      toastr.error("Please Enter Contact Number")
      return false
    }

    if (!formData.pincode || formData.pincode === "") {
      toastr.error("Please Enter Store Pincode")
      return false
    }
    if (formData.vendortype == "1") {
      if (!formData.noOfPass || formData.noOfPass == '0' || formData.noOfPass == "") {
        toastr.error("Please Enter total number of pass. value should be greater than Zero.")
        return false
      }
    }
    if (formData.swipelimit == "1") {
      if (!formData.swipeinyear || formData.swipeinyear == '0' || formData.swipeinyear == "") {
        toastr.error("Please Enter number Maximum time in year. value should be greater than Zero.")
        return false
      }
      if (!formData.monthlyswipe || formData.monthlyswipe == '0' || formData.monthlyswipe == "") {
        toastr.error("Please Enter number Maximum time in day. value should be greater than Zero.")
        return false
      }
    }
    // console.log(formData);
    // return false;

    try {
      const response = await creatstore(formDataToSend);

      toastr.options = {
        closeButton: true,
        progressBar: true,
        timeOut: 3000,
        positionClass: 'toast-top-right'
      };
      if (response.status.success) {
        toastr.success(response.message)
        setFormData({
          store_name: "",
          store_id: "",
          address: "",
          email: "",
          phone: "",
          noOfPass: "",
          dealtype: 0,
          rewardtype: 0,
          dealvalue: 0,
          ownervalue: 0,
          custvalue: 0,
          ordervalue: 0,
          rewardvalue: 0,
          swipelimit: '0',
          monthlyswipe: '0',
          swipeinyear: '0',
        });
        if (fileInputRef.current) {
          fileInputRef.current.value = '';
        }
        navigate('/store');
      } else {
        toastr.error(response.message)
      }
      localStorage.removeItem('storeEditData');
    } catch (error) {
      // console.error("Error:", error);
      toastr.error("Registration failed. Please try again.");
    }
  };

  return (
    <div className="flex flex-col md:flex-row gap-4 md:gap-4">
      <div className="w-full bg-white shadow-lg rounded-2xl p-6 space-y-6">
        <form onSubmit={handleSubmit}>
          <h2 className="text-2xl font-bold text-center">Add New Vendor</h2>

          {/* Name Fields */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">

            <div>
              <label className="block text-sm font-medium mb-2">Vendor Type</label>
              <div className=" gap-6">
                {['0', '1'].map((type) => (
                  <label key={type} className="inline-flex items-center gap-2">
                    <input
                      type="radio"
                      name="vendortype"
                      value={type}
                      checked={formData.vendortype == type}
                      onChange={handleChange}
                    // className="accent-[#f4a406]"
                    />
                    <span className="text-sm font-medium">
                      {type === '0' ? "Store" : "Events"}
                    </span>&nbsp;
                  </label>
                ))}
              </div>
            </div>
            <div>
              <label className="block text-sm font-medium mb-1">Store/Event Name</label>
              <div className="relative">
                <input
                  type="text"
                  name="store_name"
                  value={formData.store_name || ""}
                  onChange={handleChange}
                  placeholder="24/7 store/Event Comedy Carnival.."
                  className="w-full pl-10 pr-4 py-2 border rounded-xl focus:ring-2 focus:ring-[#f4a406]"
                />
                <Store className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" size={18} />
              </div>
            </div>
            <div>
              <label className="block text-sm font-medium mb-1">Store/Event ID / Code</label>
              <div className="relative">
                <input
                  readOnly
                  type="text"
                  name="store_id"
                  value={formData.store_id || ""}
                  onChange={handleChange}
                  placeholder="OZS-9876565656"
                  className="w-full pl-10 pr-4 py-2 border rounded-xl focus:ring-2 focus:ring-[#f4a406]"
                />
                <IdCard className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" size={18} />
              </div>
            </div>

            <div>
              <label className="block text-sm font-medium mb-1">Vendor Type</label>
              <div className="relative">
                <select name="type" value={formData.type || ""} onChange={handleChange} className="w-full pl-10 pr-4 py-2 border rounded-xl focus:ring-2 focus:ring-[#f4a406]"
                >
                  <option value="" disabled>Select</option>
                  <option value="Event">Event</option>
                  <option value="Restaurant">Restaurant</option>
                  <option value="Meat_Shop">Meat Shop</option>
                  <option value="Salon">Beauty & Salon</option>
                  <option value="Retail">Retail</option>
                  <option value="Wholesale">Wholesale</option>
                  <option value="Online">Online</option>
                  <option value="Boutiques">Boutiques</option>
                  <option value="Electronics">Electronics</option>
                  <option value="Malls">Malls</option>
                  <option value="Supermarkets">Supermarkets</option>
                  <option value="Hypermarkets">Hypermarkets</option>
                  <option value="Franchises">Franchises</option>
                  <option value="Convenience_Stores">Convenience Stores</option>
                  <option value="Discount_Stores">Discount Stores</option>
                  <option value="E-commerce_Retailers">E-commerce Retailers</option>
                  <option value="General_Store">General Store</option>
                  <option value="Online_Retailing">Online Retailing</option>
                  <option value="Itinerant_Retailers">Itinerant Retailers</option>
                </select>
                <ListCheck className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" size={18} />
              </div>
            </div>

            <div>
              <label className="block text-sm font-medium mb-1">Contact Name</label>
              <div className="relative">
                <input
                  type="text"
                  name="contact_name"
                  value={formData.contact_name || ""}
                  onChange={handleChange}
                  placeholder="Doe"
                  className="w-full pl-10 pr-4 py-2 border rounded-xl focus:ring-2 focus:ring-[#f4a406]"
                />
                <User className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" size={18} />
              </div>
            </div>

            <div>
              <label className="block text-sm font-medium mb-1">Password</label>
              <div className="relative">
                <input
                  id="password"
                  type="password"
                  name="password"
                  value={formData.password || ""}
                  className="w-full pl-10 pr-4 py-2 border rounded-xl focus:ring-2 focus:ring-[#f4a406]"
                  autoComplete="new-password"
                  onChange={handleChange}
                />
                <LockIcon className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" size={18} />
              </div>
            </div>

            <div>
              <label className="block text-sm font-medium mb-1">Password</label>
              <div className="relative">
                <input
                  id="password_confirmation"
                  type="password"
                  name="password_confirmation"
                  value={formData.password_confirmation || ""}
                  className="w-full pl-10 pr-4 py-2 border rounded-xl focus:ring-2 focus:ring-[#f4a406]"
                  autoComplete="new-password"
                  onChange={handleChange}
                />
                <LockIcon className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" size={18} />
              </div>
            </div>

            <div>
              <label className="block text-sm font-medium mb-1">Email</label>
              <div className="relative">
                <input
                  type="email"
                  name="email"
                  value={formData.email || ""}
                  onChange={handleChange}
                  placeholder="Store’s official email"
                  className="w-full pl-10 pr-4 py-2 border rounded-xl focus:ring-2 focus:ring-[#f4a406]"
                />
                <Mail className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" size={18} />
              </div>
            </div>

            <div>
              <label className="block text-sm font-medium mb-1">Phone Number</label>
              <div className="flex">
                {/* Country Code Select */}
                <div className="relative">
                  <select
                    name="country_code"
                    value={formData.country_code || "+91"}
                    onChange={handleChange}
                    className="h-full rounded-l-xl border border-r-0 pl-3 pr-2 py-2 focus:ring-2 focus:ring-[#f4a406]"
                  >
                    {/* <option value="+1">US +1</option> */}
                    <option value="91">IN +91</option>
                    <option value="971">AE +971</option>
                    {/* <option value="+44">🇬🇧 +44</option>
                    <option value="+61">🇦🇺 +61</option> */}
                  </select>
                </div>

                {/* Phone Number Input */}
                <div className="relative flex-1">
                  <input
                    type="tel"
                    name="phone"
                    value={formData.phone || ""}
                    onChange={handleChange}
                    placeholder="234 567 890"
                    className="w-full pl-10 pr-4 py-2 border rounded-r-xl focus:ring-2 focus:ring-[#f4a406]"
                  />
                  <Phone className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" size={18} />
                </div>
              </div>
            </div>

            <div>
              <label className="block text-sm font-medium mb-1">Alternate Phone Number</label>
              <div className="relative">
                <input
                  type="tel"
                  name="alt_mobile"
                  value={formData.alt_mobile || ""}
                  onChange={handleChange}
                  placeholder="+1 234 567 890"
                  className="w-full pl-10 pr-4 py-2 border rounded-xl focus:ring-2 focus:ring-[#f4a406]"
                />
                <Phone className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" size={18} />
              </div>
            </div>

            <div>
              <NewPlaceAutocomplete />
            </div>


            <div>
              <label className="block text-sm font-medium mb-1">Country</label>
              <div className="relative">
                <label htmlFor="country" value="Country" />
                <select id="country" name="country"
                  // onChange={e => { handleState(e); }}
                  onChange={e => {
                    const value = e.target.value;
                    setFormData(prev => ({ ...prev, country: value }));
                    handleState(e);
                  }}
                  value={formData.country || ""}
                  className="w-full pl-10 pr-4 py-2 border rounded-xl focus:ring-2 focus:ring-[#f4a406]">
                  <option value="0">Select</option>
                  {CountryList && CountryList.length > 0 && CountryList.map((item, key) => (
                    <option key={key} value={item.id}>{item.name}</option>
                  ))}
                </select>
                <ListCheck className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" size={18} />
              </div>
            </div>

            <div>
              <label className="block text-sm font-medium mb-1">State</label>
              <div className="relative">
                <label htmlFor="state" value="state" />
                <select id="state" name="state"
                  onChange={e => {
                    const value = e.target.value;
                    setFormData(prev => ({ ...prev, state: value }));
                    handleCity(e);
                  }}
                  value={formData.state || ""}
                  className="w-full pl-10 pr-4 py-2 border rounded-xl focus:ring-2 focus:ring-[#f4a406]">
                  <option value="0">Select</option>
                  {StateList && StateList.length > 0 && StateList.map((item, key) => (
                    <option key={key} value={item.id}>{item.name}</option>
                  ))}
                </select>
                <ListCheck className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" size={18} />
              </div>
            </div>

            <div>
              <label className="block text-sm font-medium mb-1">City</label>
              <div className="relative">
                <label htmlFor="city" value="city" />
                <select id="city" name="city"
                  onChange={e => { const value = e.target.value; setFormData(prev => ({ ...prev, city: value })); }}
                  value={formData.city || ""}
                  className="w-full pl-10 pr-4 py-2 border rounded-xl focus:ring-2 focus:ring-[#f4a406]">
                  <option value="0">Select</option>
                  {CityList && CityList.length > 0 && CityList.map((item, key) => (
                    <option key={key} value={item.id}>{item.cityName}</option>
                  ))}
                </select>
                <ListCheck className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" size={18} />
              </div>
            </div>


            <div>
              <label className="block text-sm font-medium mb-1">Website URL</label>
              <div className="relative">
                <input
                  type="text"
                  name="website_url"
                  value={formData?.website_url || ""}
                  onChange={handleChange}
                  placeholder="www.xyzabc.com"
                  className="w-full pl-10 pr-4 py-2 border rounded-xl focus:ring-2 focus:ring-[#f4a406]"
                />
                <ExternalLink className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" size={18} />
              </div>
            </div>

            <div>
              <label className="block text-sm font-medium mb-1">Pincode</label>
              <div className="relative">
                <input
                  type="text"
                  name="pincode"
                  value={formData?.pincode || ""}
                  onChange={handleChange}
                  placeholder="Pincode"
                  className="w-full pl-10 pr-4 py-2 border rounded-xl focus:ring-2 focus:ring-[#f4a406]"
                />
                <MapPinIcon className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" size={18} />
              </div>
            </div>

          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-medium mb-1">Description</label>
              <div className="relative">
                <textarea
                  type="text"
                  name="description"
                  value={formData.description || ""}
                  onChange={handleChange}
                  placeholder="About Store"
                  className="w-full pl-10 pr-4 py-2 border rounded-xl focus:ring-2 focus:ring-[#f4a406]"
                />
                <AlignLeft className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" size={18} />
              </div>
            </div>
            <div>
              <label className="block text-sm font-medium mb-1">address</label>
              <div className="relative">
                <input
                  type="text"
                  name="address"
                  value={formData.address || ""}
                  onChange={handleChange}
                  placeholder="Store Address"
                  className="w-full pl-10 pr-4 py-2 border rounded-xl focus:ring-2 focus:ring-[#f4a406]"
                />
                <AlignLeft className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" size={18} />
              </div>
            </div>

            <div>
              <label className="block text-sm font-medium mb-2">OTP Allowed</label>
              <div className=" gap-6">
                {['1', '0'].map((type) => (
                  <label key={type} className="inline-flex items-center gap-2">
                    <input
                      type="radio"
                      name="OTPAllowed"
                      value={type}
                      checked={formData.OTPAllowed == type}
                      onChange={handleChange}
                    // className="accent-[#f4a406]"
                    />
                    <span className="text-sm font-medium">
                      {type === '1' ? "Yes" : "No"}
                    </span>&nbsp;
                  </label>
                ))}
              </div>
            </div>
            <div>
              <label className="block text-sm font-medium mb-2">Face Recognition Allowed </label>
              <div className=" gap-6">
                {['1', '0'].map((type) => (
                  <label key={type} className="inline-flex items-center gap-2">
                    <input
                      type="radio"
                      name="FaceRecognition"
                      value={type}
                      checked={formData.FaceRecognition == type}
                      onChange={handleChange}
                    // className="accent-[#f4a406]"
                    />
                    <span className="text-sm font-medium">
                      {type === '1' ? "Yes" : "No"}
                    </span>&nbsp;
                  </label>
                ))}
              </div>
            </div>

            <div>
              <label className="block text-sm font-medium mb-2">
                Swipe Rules
                <p className="italic text-gray-600 font-thin">
                  No limit means user can swipe unlimited time at this store. For Custom Swipe limit should be in number of times. Like 5,10,20,50...
                  {/* <InfoIcon className="absolute left-20 top-1/2 -translate-y-1/2 text-red-400" size={18} /> */}
                </p>
              </label>
              <div className=" gap-6">
                {["0", "1"].map((type) => (
                  <label key={type} className="inline-flex items-center gap-2">
                    <input
                      type="radio"
                      name="swipelimit"
                      value={type}
                      checked={formData.swipelimit == type}
                      onChange={handleChange}
                    // className="accent-[#f4a406]"
                    />
                    <span className="text-sm font-medium">
                      {type === "0" ? "No Limit" : "Custom Limit"}
                    </span>&nbsp;
                  </label>
                ))}

                {formData.swipelimit == 1 && (
                  <>
                    <div className=" gap-6">
                      <label className="block text-sm font-medium mb-2">Maximum time in Year(s)  </label>
                      <input
                        type="number"
                        name="swipeinyear"
                        value={formData.swipeinyear || ""}
                        onChange={handleChange}
                        placeholder="Enter number"
                        className="w-full pl-5 pr-4 py-2 border rounded-xl focus:ring-2 focus:ring-[#f4a406]"
                      />
                    </div>
                    <div className=" gap-6">
                      <label className="block text-sm font-medium mb-2">Maximum time in Day(s)</label>
                      <input
                        type="number"
                        name="monthlyswipe"
                        value={formData.monthlyswipe || ""}
                        onChange={handleChange}
                        placeholder="Enter number"
                        className="w-full pl-5 pr-4 py-2 border rounded-xl focus:ring-2 focus:ring-[#f4a406]"
                      />
                    </div>
                  </>
                )}

              </div>
            </div>
            {formData.vendortype == 1 && (
              <>
                <div>
                  <label className="block text-sm font-medium mb-1">Event Date</label>
                  <div className="relative">
                    <DateInput
                      valueFormat="DD-MM-YYYY"
                      minDate={new Date()}
                      placeholder="Pick End date"
                      value={formData.event_date}
                      onChange={(date) => {
                        handleChangeDate(date, 'event_date');
                      }}
                      leftSection={<CalendarDays size={18} className="text-gray-400" />}
                      className="w-full rounded-xl"
                    />
                    {/* <Flatpickr
                      value={new Date(formData.event_date)}
                      // onChange={([date]) => handleChange(date, 'event_date')}
                      onChange={([date]) => {
                        handleChangeDate(date, 'event_date')
                      }}
                      options={{
                        minDate: 'today',
                        enableTime: false,
                        time_24hr: false,
                        defaultDate: null,
                        altFormat: 'Y-m-d (UTCZ)',
                        dateFormat: "d/m/Y", // Format: DD/MM/YYYY
                      }}
                      placeholder="Select a date"
                      className="w-full pl-10 pr-4 py-2 border rounded-xl focus:ring-2 focus:ring-[#f4a406]"
                    />
                    <CalendarDays className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" size={18} /> */}
                  </div>
                </div>
                <div>
                  <label className="block text-sm font-medium mb-1">Total No. Of Pass</label>
                  <div className="relative">
                    <input
                      type="number"
                      name="noOfPass"
                      value={formData.noOfPass || ""}
                      onChange={handleChange}
                      placeholder="Enter number"
                      className="w-full pl-10 pr-4 py-2 border rounded-xl focus:ring-2 focus:ring-[#f4a406]"
                    />
                    <Binary className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" size={18} />
                  </div>
                </div>
              </>

            )}


            {/* <div>
              <label className="block text-sm font-medium mb-2">Deals In</label>
              <div className=" gap-6">
                {["0", "1"].map((type) => (
                  <label key={type} className="inline-flex items-center gap-2">
                    <input
                      type="radio"
                      name="dealtype"
                      value={type}
                      checked={formData.dealtype == type}
                      onChange={handleChange}
                    // className="accent-[#f4a406]"
                    />
                    <span className="text-sm font-medium">
                      {type === "0" ? "Percentage" : "Fixed"}
                    </span>&nbsp;
                  </label>
                ))}
                <div className=" gap-6">
                  <label className="block text-sm font-medium mb-2">Total value</label>
                  <input
                    type="number"
                    name="dealvalue"
                    value={formData.dealvalue || ""}
                    onChange={handleChange}
                    placeholder="Total value"
                    className="w-full pl-5 pr-4 py-2 border rounded-xl focus:ring-2 focus:ring-[#f4a406]"
                  />
                </div>
                <div className=" gap-6">
                  <label className="block text-sm font-medium mb-2">Value for custmer</label>
                  <input
                    type="number"
                    name="custvalue"
                    value={formData.custvalue || ""}
                    onChange={handleChange}
                    placeholder="value for custmer"
                    className="w-full pl-5 pr-4 py-2 border rounded-xl focus:ring-2 focus:ring-[#f4a406]"
                  />
                </div>
                <div className=" gap-6">
                  <label className="block text-sm font-medium mb-2">Value for owner</label>
                  <input
                    type="number"
                    name="ownervalue"
                    value={formData.ownervalue || ""}
                    onChange={handleChange}
                    placeholder="value owner"
                    className="w-full pl-5 pr-4 py-2 border rounded-xl focus:ring-2 focus:ring-[#f4a406]"
                  />
                </div>
              </div>
            </div> */}
            {/* <div>
              <label className="block text-sm font-medium mb-2">Reward formula</label>
              <div className=" gap-6">

                <div className=" gap-6">
                  <label className="block text-sm font-medium mb-2">Order value</label>
                  <input
                    type="number"
                    name="ordervalue"
                    value={formData.ordervalue || ""}
                    onChange={handleChange}
                    placeholder="Order value"
                    className="w-full pl-5 pr-4 py-2 border rounded-xl focus:ring-2 focus:ring-[#f4a406]"
                  />
                </div>
                {["0", "1"].map((type) => (
                  <label key={type} className="inline-flex items-center gap-2">
                    <input
                      type="radio"
                      name="rewardtype"
                      value={type}
                      checked={formData.rewardtype == type}
                      onChange={handleChange}
                    // className="accent-[#f4a406]"
                    />
                    <span className="text-sm font-medium">
                      {type === "0" ? "Percentage" : "Fixed"}
                    </span>&nbsp;
                  </label>
                ))}
                <div className=" gap-6">
                  <label className="block text-sm font-medium mb-2">Get Reward value</label>
                  <input
                    type="number"
                    name="rewardvalue"
                    value={formData.rewardvalue || ""}
                    onChange={handleChange}
                    placeholder="Enter value % OR Fixed"
                    className="w-full pl-5 pr-4 py-2 border rounded-xl focus:ring-2 focus:ring-[#f4a406]"
                  />
                </div>

              </div>
            </div> */}

            <div>
              <label className="block text-sm font-medium mb-1">Upload Image</label>
              <div className="flex items-center gap-4">
                <div className="relative flex-1">
                  <input
                    type="file"
                    ref={fileInputRef}
                    name="store_logo"
                    accept="image/*"
                    onChange={handleChange}
                    className="w-full pl-10 pr-4 py-2 border rounded-xl focus:ring-2 focus:ring-[#f4a406] file:mr-4 file:py-2 file:px-4 file:rounded-full file:border-0 file:text-sm file:font-semibold file:bg-[#f4a406] file:text-white hover:file:bg-yellow-600"
                  />
                  <Image className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" size={18} />
                </div>

                {formData.store_logo && (
                  <div className="w-32 h-24 border rounded-xl overflow-hidden">
                    <img
                      src={
                        typeof formData.store_logo === 'string'
                          ? `${formData.store_logo}`
                          : formData.store_logo_preview
                      }
                      alt="Uploaded Preview"
                      className="w-full h-full object-cover"
                    />
                  </div>
                )}
              </div>
            </div>


          </div>

          <br></br>

          {/* Submit */}
          <button
            type="submit"
            className="w-full bg-[#f4a406] text-white py-2 rounded-xl hover:bg-[#d89005] transition-colors"
          >
            Save
          </button>
        </form>
      </div >

    </div >
  );
}
